// extracted by mini-css-extract-plugin
export var actionText = "_r8-4";
export var container = "_r8-0";
export var leftSection = "_r8-1";
export var rightSection = "_r8-2";
export var settingsButton = "_r8-6";
export var settingsIcon = "_r8-7";
export var shortcut = "_r8-5";
export var shortcutGroup = "_r8-3";